import { render, staticRenderFns } from "./QuizPage.vue?vue&type=template&id=63dd93e2&scoped=true&"
import script from "./QuizPage.vue?vue&type=script&lang=js&"
export * from "./QuizPage.vue?vue&type=script&lang=js&"
import style0 from "./QuizPage.vue?vue&type=style&index=0&id=63dd93e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dd93e2",
  null
  
)

export default component.exports